export default __webpack_public_path__ + "static/media/ic_uni_arbitrum.1d07524a.svg";